import SectionHeader from "../../components/section_header/SectionHeader";
import "./partners.scss";
import logo1 from "../../assets/partners/logo1.webp";
// import logo2 from "../../assets/partners/logo2.webp";
import logo3 from "../../assets/partners/logo3.webp";
import logo4 from "../../assets/partners/logo4.webp";
// import logo5 from "../../assets/partners/logo5.webp";
import logo6 from "../../assets/partners/logo6.webp";
import logo7 from "../../assets/partners/logo7.webp";
// import logo8 from "../../assets/partners/logo8.webp";
import logo9 from "../../assets/partners/logo9.webp";
import Marquee from "react-fast-marquee";
const Partners = () => {
  const logos = [logo1, logo3, logo4, logo6, logo7, logo9];
  return (
    <div className="partners_main">
      <SectionHeader name={"OUR PARTNERS"} />
      <div className="partners_containers">
        <div className="partner_logos">
          {/* {window.innerWidth < 1000 ? (
            <>
              <Marquee
                velocity={25}
                scatterRandomly={true}
                gradient={true}
                gradientWidth={window.innerWidth < 600 ? 10 : 50}
              >
                {logos.slice(0, 4).map((item, index) => (
                  <img key={index} src={item} alt={"Partners"} />
                ))}
              </Marquee>
              <Marquee
                velocity={25}
                scatterRandomly={true}
                gradient={true}
                gradientWidth={window.innerWidth < 600 ? 10 : 50}
              >
                {logos.slice(4).map((item, index) => (
                  <img key={index} src={item} alt={"Partners"} />
                ))}
              </Marquee>
            </>
          ) : (
            <>
              <Marquee
                velocity={25}
                scatterRandomly={true}
                gradient={true}
                gradientWidth={50}
              >
                {logos.map((item, index) => (
                  <img key={index} src={item} alt={"Partners"} />
                ))}
              </Marquee>
            </>
          )} */}

          <>
            <Marquee
              velocity={25}
              scatterRandomly={true}
              gradient={true}
              gradientWidth={50}
            >
              {logos.map((item, index) => (
                <img key={index} src={item} alt={"Partners"} />
              ))}
            </Marquee>
          </>
        </div>
      </div>
    </div>
  );
};

export default Partners;
